import{b as o}from"./ninox-components-3BPDSF2O.js";var t={};o(t,{mono:()=>n,sans:()=>s});var s="'Noto Sans', sans-serif",n="'Noto Sans Mono', monospace";export{s as a,n as b,t as c};
//# sourceMappingURL=ninox-components-YAP3BY3K.js.map